<div class="bn-dialog bn-expired-trial p-2 pb-0">
  <div
    class="bn-dialog__close"
    (click)="onClose()">
    <fa-icon
      aria-label="Close"
      icon="xmark"
      size="lg" />
  </div>
  <div class="bn-dialog__body">
    <div class="row">
      <div class="col-6 d-none d-md-block text-center">
        <div class="bn-expired-trial__title">Your trial period has ended.</div>
        <img
          class="bn-expired-trial__image"
          src="/assets/web-ui/images/bunny-sand-clock.svg" />
      </div>
      <div class="col-12 col-md-6">
        <div class="bn-expired-trial__title d-block d-md-none text-center text-md-left ms-md-6">Your trial period has ended.</div>
        <div class="bn-expired-trial__content">
          <div class="bn-expired-trial__content__title">Continue using bunny.net services</div>
          <p>To continue using bunny.net services for your projects, you need to recharge your account.</p>
          <hr class="mt-3 mb-4" />
          <div class="row">
            <div class="col-6">
              <fa-duotone-icon
                class="bn-expired-trial__usage__item__icon"
                size="lg"
                [icon]="['fad', 'circle-dollar']" />
              <div class="bn-expired-trial__usage__item__value">
                {{ usedTrialBalance ? (usedTrialBalance | currency: appConfig.currencySymbol : undefined : '1.2') : appConfig.currencySymbol + '0.00' }} /
                {{ totalTrialBalance ? (totalTrialBalance | currency: appConfig.currencySymbol : undefined : '1.2') : appConfig.currencySymbol + '0.00' }}
              </div>
              <div>Trial usage</div>
            </div>
            <div class="col-12 my-3">
              <div class="bn-expired-trial__usage__progress-bar">
                <div
                  class="bn-expired-trial__usage__progress-bar__cover"
                  [style.width]="100 - (totalTrialBalance ? (usedTrialBalance / totalTrialBalance) * 100 : 0) + '%'"></div>
              </div>
            </div>
          </div>

          <hr class="my-3" />
          <div class="bn-expired-trial__content__title">Continue</div>
          <bn-web-ui-list-with-icon
            class="text-dark-7"
            [data]="listData" />

          <div class="bn-dialog__actions mt-5">
            <button
              bn-web-ui-button
              itemStyle="primary"
              size="lg"
              [fullWidth]="true"
              (click)="rechargeAcc()">
              Recharge Your Account
            </button>
            <p class="mt-2 text-center">
              Working on a bigger project?
              <a
                class="bn-main-menu__link cursor-pointer"
                (click)="contactSales()"
                >Get in touch with sales.</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
